import type { Message } from "instantdb/types";
import { instantClientDB } from "instantdb/instantClient";
import { id } from "@instantdb/admin";

// Get all messages for a user for a particular chatId
export function getMessages({ chatId }: { chatId?: string }) {
  const { data, isLoading } = instantClientDB.useQuery(
    chatId
      ? {
          chats: {
            $: {
              where: {
                id: chatId,
              },
            },
            messages: {
              file: {},
            },
          },
        }
      : {},
  );

  if (!chatId) {
    return {
      messages: [],
      isLoading: false,
    };
  }

  // Get messages from the chat and filter by user access
  const chat = data?.chats?.[0];
  const messages = chat?.messages ?? [];

  console.log({ messages });
  return {
    messages,
    isLoading: !!chatId && isLoading,
  };
}

// Create or update a message
export async function upsertMessage(message: Partial<Message>, chatId: string) {
  const { id: inputId, ...messageData } = message;
  const messageId = inputId ?? id();

  // Build transaction steps - include chatId in message data and link to chat
  const txSteps = [
    instantClientDB.tx.messages[messageId]
      .update({
        ...messageData,
        chatId,
      })
      .link({
        chat: chatId,
      }),
    // Update the chat's updatedAt timestamp
    instantClientDB.tx.chats[chatId].update({
      updatedAt: Date.now(),
    }),
  ];

  await instantClientDB.transact(txSteps).catch((error) => {
    console.error("Error upserting messages:", message, error);
  });

  return messageId;
}

// Delete a message
export async function deleteMessage(id: string) {
  await instantClientDB.transact([instantClientDB.tx.messages[id].delete()]);
}
